import {Component, OnInit} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {AuthenticationService} from '../../../../core/services/authentication/authentication.service';
import {UserInfo} from '../../../../core/models/user/user-info.model';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {RecaptchaV3Service} from '../../../../core/services/recaptcha/recaptcha-v3-service';
import {UserSelfService} from '../../../../core/services/user/user-self.service';
import {AlertComponent} from '../../../../components/alert/alert.component';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-settings-index',
  imports: [
    TranslateModule,
    AlertComponent,
    ReactiveFormsModule,
    NgIf
  ],
  templateUrl: './settings-index.component.html',
  styleUrl: './settings-index.component.scss'
})
export class SettingsIndexComponent implements OnInit {

  emailChangeForm!: FormGroup;
  emailChangeLoading: boolean = false;
  emailChangeError: string | null = null;

  changePasswordForm!: FormGroup;
  changePasswordLoading: boolean = false;
  changePasswordError: string | null = null;

  constructor(
    private readonly authService: AuthenticationService,
    private readonly formBuilder: FormBuilder,
    private readonly recaptchaService: RecaptchaV3Service,
    private readonly selfService: UserSelfService
  ) {
  }

  get user(): UserInfo | undefined {
    return this.authService.userData;
  }

  ngOnInit(): void {
    this._initForms();
  }

  private _initForms() {
    this.emailChangeForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });

    this.changePasswordForm = this.formBuilder.group({
      currentPassword: ['', [Validators.required]],
      newPassword: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(32), Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$&+,:;=?@#|\'<>.^*()%!-])[a-zA-Z\\d$&+,:;=?@#|\'<>.^*()%!-]{10,}$')]],
      confirmPassword: ['', [Validators.required]]
    });
  }

  submitChangeEmail() {
    if (this.emailChangeForm.invalid) {
      return;
    }

    const { email } = this.emailChangeForm.getRawValue();
    if (email === this.user?.email) {
      return;
    }

    this.recaptchaService.execute('userChangeEmail', (recaptchaToken) => {

    });
  }

  submitChangePassword() {
    if (this.changePasswordForm.invalid) {
      return;
    }

    const { currentPassword, newPassword, confirmPassword } = this.changePasswordForm.getRawValue();
    if (newPassword !== confirmPassword) {
      return;
    }

    this.recaptchaService.execute('userChangePassword', (recaptchaToken) => {

    });
  }

  protected readonly onsubmit = onsubmit;
}
